import React, { Component } from "react";
import "../Styles/card.css";
import "font-awesome/css/font-awesome.min.css";

class Card extends Component {
  state = {
    bookmarked: false,
    like: false,
    likes: 0,
    dislike: false,
    dislikes: 0
  };
  handleBookmark = () => {
    this.setState({ bookmarked: !this.state.bookmarked });
  };
  handleLike = () => {
    this.setState({
      like: !this.state.like,
      likes: this.state.likes + 1
    });
    if (this.state.like) {
      this.setState({ likes: this.state.likes - 1 });
    } else if (this.state.dislike) {
      this.setState({
        dislike: false,
        dislikes: this.state.dislikes - 1
      });
    }
  };
  handleDislike = () => {
    this.setState({
      dislike: !this.state.dislike,
      dislikes: this.state.dislikes + 1
    });
    if (this.state.dislike) {
      this.setState({ dislikes: this.state.dislikes - 1 });
    } else if (this.state.like) {
      this.setState({
        like: false,
        likes: this.state.likes - 1
      });
    }
  };

  render() {
    return (
      <div className="card" key={this.props.id}>
        <img
          src={this.props.imageUrl}
          className="image"
          alt={this.props.imageTitle}
        />
        <div className="content">
          <div className="tittle-icon">
            <span className="heading">{this.props.imageTitle}</span>
            <div
              onClick={() => this.handleBookmark()}
              className="m-t"
            >
              <i
                className="fa fa-bookmark icon-size"
                style={this.state.bookmarked ? { color: "#ECCC00" } : null}
              />
            </div>
          </div>
          <span className="Description">{this.props.des}</span>
          <div className="dislike">
            <span className="readMore">{this.props.read}</span>
            <div
              className="likeButton"
              onClick={() => this.handleLike()}
            >
              <i
                className="fa fa-thumbs-up icon-size"
                style={this.state.like ? { color: "#1E8DDE" } : null}
              >
                {" "}{this.state.likes}
              </i>
            </div>
            <div
              className="dislikeButton"
              onClick={() => this.handleDislike()}
            >
              <i
                className="fa fa-thumbs-down icon-size"
                style={this.state.dislike ? { color: "darkred" } : null}
              >
                {" "}{this.state.dislikes}
              </i>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Card;
